// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__2QyAJ","author":"Table_author__2DvTd","authorImage":"Table_authorImage__2743q","unreadRow":"Table_unreadRow__YNUQK"};